import { useState } from "react"

import { Button } from "@/components/ui/button"
import { useI18n } from "@/i18n"

const DISMISSED_KEY = "celver-copilot:welcome-dismissed"

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === "1"
  } catch {
    return false
  }
}

/** First-visit hint on the empty chat screen; hidden for good once dismissed or the guide was opened. */
export function WelcomeCard({ onOpenGuide }: { onOpenGuide: () => void }) {
  const { t } = useI18n()
  const [hidden, setHidden] = useState(wasDismissed)
  if (hidden) return null

  const dismiss = () => {
    setHidden(true)
    try {
      localStorage.setItem(DISMISSED_KEY, "1")
    } catch {
      // shown again next visit
    }
  }

  return (
    <div role="note" className="max-w-md rounded-lg border border-border bg-card p-4 text-left text-sm">
      <p className="font-medium">{t("help.welcomeTitle")}</p>
      <p className="mt-1 text-fg3">
        {t("help.welcomeBodyBefore")}<code>/help</code>{t("help.welcomeBodyAfter")}
      </p>
      <div className="mt-3 flex gap-2">
        <Button
          size="sm"
          onClick={() => {
            dismiss()
            onOpenGuide()
          }}
        >
          {t("help.openGuide")}
        </Button>
        <Button size="sm" variant="ghost" onClick={dismiss}>
          {t("help.dismiss")}
        </Button>
      </div>
    </div>
  )
}
